import { React, useRef, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';

import MemberShipSelectBox from '../../../../../Component/MemberComponent/MemberShipSelectBox.js';
import CalenderInput from '../../../../../Component/MemberComponent/CalenderInput.js';
import PaymentInput from '../../../../../Component/MemberComponent/PaymentInput.js';

import FetchModule from '../../../../Share/Network/FetchModule.js';
import MemberShipTotalMaxCountInput from '../../../../../Component/MemberComponent/MemberShipTotalMaxCountInput.js';
import DiscountPaymentInput from '../../../../../Component/MemberComponent/DiscountPaymentInput.js';
import CategorySelectBox from '../../../../../Component/MemberComponent/CategorySelectBox.js';
import PointInput from '../../../../../Component/MemberComponent/PointInput.js';
import { useLanguage } from '../../../../../Context/LanguageContext';

const MemberShipAddModal = forwardRef((props, ref) => {
  const { data, userData, totalPoint, index, isExtend, cancel, registerClick } = props;
  const history = useHistory();
  const { t } = useLanguage();

  const [isUsing, setIsUsing] = useState(false);
  const [lessonData, setLessonData] = useState([]);
  const [categoryData, setCategoryData] = useState(false);
  const [memberShipData, setMemberShipData] = useState(false);
  const [divisionMemberShipData, setDivisionMemberShipData] = useState(false);
  const [maxCount, setMaxCount] = useState(0);
  const [validity, setValidity] = useState(0);
  const [validityUnit, setValidityUnit] = useState('day');
  const [totalPrice, setTotalPrice] = useState(0);
  const [notReceivedPrice, setNotReceivedPrice] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [approvalDate, setApprovalDate] = useState('');
  const [prevSalesColor, setPrevSalesColor] = useState('#595959');

  const LessonSelectRef = useRef();
  const TotalMaxRef = useRef();
  const CategorySelectRef = useRef();
  const MemberShipSelectRef = useRef();
  const DiscountPaymentRef = useRef();
  const CardPaymentRef = useRef();
  const CashPaymentRef = useRef();
  const PointRef = useRef();
  const StartCalenderRef = useRef();
  const EndCalenderRef = useRef();
  const ApprovalCalenderRef = useRef();

  useImperativeHandle(ref, () => ({
    getIsUsing: () => {
      return isUsing;
    },
    getMemberShipId: () => {
      return MemberShipSelectRef.current.getMemberShipId();
    },
    getMemberShipName: () => {
      return MemberShipSelectRef.current.getValue();
    },
    getStartDate: () => {
      return startDate;
    },
    getEndDate: () => {
      return endDate;
    },
    getMemberShipData: () => {
      return MemberShipSelectRef.current.getObjectVal();
    },
    getCardPrice: () => {
      return CardPaymentRef.current.getValue();
    },
    getCashPrice: () => {
      return CashPaymentRef.current.getValue();
    },
    getDiscountPrice: () => {
      return DiscountPaymentRef.current.getValue();
    },
    getPoint: () => {
      return PointRef.current.getValue();
    },
    getApprovalDate: () => {
      return approvalDate;
    },
    getTotalMax: () => {
      return TotalMaxRef.current.getValue();
    },
    getNotReceivedPrice: () => {
      return notReceivedPrice;
    }
  }))

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');
        if (responseData.status === 200) {
          setMemberShipData(responseData.data.memberShips);
          setCategoryData(responseData.data.categories);
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }, [history])

  useEffect(() => {
    if (data === undefined || !isExtend) return;

    if (categoryData) CategorySelectRef.current.setValue({ id: data[index].categoryId, name: data[index].categoryName });
    if (memberShipData) MemberShipSelectRef.current.setValue({ id: data[index].memberShipId, name: data[index].memberShipName, validity: data[index].validity });

    setMaxCount(data[index].totalMax);
    TotalMaxRef.current.setValue(data.totalMax);
    setTotalPrice(data[index].totalPrice);
    setNotReceivedPrice(data[index].totalPrice);

    CardPaymentRef.current.setValue(data[index].cardPrice);
    CashPaymentRef.current.setValue(data[index].cashPrice);

    setEndDate(moment().add(data[index].validity, 'days').format('YYYY.MM.DD'));
  }, [data, index, categoryData, memberShipData])

  useEffect(() => {
    if (isUsing) {
      CategorySelectRef.current.setValue({ name: '선택' });
      MemberShipSelectRef.current.setValue({ name: '선택' });

      setStartDate('');
      setEndDate('');
      setApprovalDate('');
    }
    else {
      setStartDate(moment().format('YYYY.MM.DD'));
      setEndDate(moment().format('YYYY.MM.DD'));
      setApprovalDate(moment().format('YYYY.MM.DD'));
    }
  }, [isUsing])

  // 시작날짜가 변경될때마다 회원권 종료일 자동 계산 ( 유효기간이 0이거나 시작날짜가 정해지지 않으면 무시 )
  useEffect(() => {
    if (startDate === '') return;

    let division = 'days';

    if (validityUnit === 'year') division = 'year';
    else if (validityUnit === 'month') division = 'month';

    setEndDate(moment(startDate, 'YYYY.MM.DD').add(validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
  }, [startDate, validity, validityUnit])

  // 금액 입력시 미수금 정리 // 
  function changeValue() {
    let card = CardPaymentRef.current.getValue();
    let cash = CashPaymentRef.current.getValue();
    let discount = DiscountPaymentRef.current.getValue();
    let point = PointRef.current.getValue();

    setNotReceivedPrice((totalPrice - (card + cash + discount + point)) > 0 ? (totalPrice - (card + cash + discount + point)) : 0);
  }

  // 카테고리 선택시 //
  function changeCategorySelectVal(value) {
    let newDataList = [];

    for (let i = 0; i < memberShipData.length; i++) {
      if (memberShipData[i].categoryId === value.id) newDataList.push(memberShipData[i]);
    }

    setDivisionMemberShipData(newDataList);
    MemberShipSelectRef.current.setData(newDataList);

    if (newDataList.length === 0) MemberShipSelectRef.current.setValue({ id: -1, name: '선택' });
    else MemberShipSelectRef.current.setValue({ id: 0, name: '선택' });

    TotalMaxRef.current.setValue('');
    setTotalPrice(0);
    CardPaymentRef.current.setValue('');
    CashPaymentRef.current.setValue('');
    DiscountPaymentRef.current.setValue('');
  }

  // 회원권 선택시 //
  function changeMemberShipSelectVal(value) {
    setMaxCount(value.totalMax);
    setNotReceivedPrice(value.price);
    TotalMaxRef.current.setValue(value.totalMax);
    setValidity(value.validity);
    setValidityUnit(value.validityUnit);
    setTotalPrice(value.price);

    CardPaymentRef.current.setValue('');
    CashPaymentRef.current.setValue('');
    DiscountPaymentRef.current.setValue('');

    setNotReceivedPrice(value.price);
  }

  // 달력 클릭시 //
  function CalenderClick(className) {
    if (className === 'StartCalender') EndCalenderRef.current.closeCalender();
    else StartCalenderRef.current.closeCalender();
  }

  // 이전 등록 회원권 정보 뷰 정리 //
  function onCalcPrevSalesInfo(className) {
    if (userData === undefined || userData.prevSales === undefined || userData.prevMemberShip === undefined) return '';

    if (className === 'MemberShipName') return userData.prevSales.itemName;
    else if (className === 'Date') return moment(userData.prevUsage.startDate).format('YY.MM.DD') + ' - ' + moment(userData.prevUsage.endDate).format('YY.MM.DD');
    else if (className === 'TotalMax') return userData.prevUsage.totalMax === -1 ? t('memberDetail.membershipAddModal.noLimit') : userData.prevUsage.totalMax;
    else if (className === 'TotalPrice') return (parseInt(userData.prevSales.cashPrice) + parseInt(userData.prevSales.cardPrice)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    else if (className === 'CardPrice') return (parseInt(userData.prevSales.cardPrice)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    else if (className === 'CashPrice') return (parseInt(userData.prevSales.cashPrice)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    else if (className === 'NotReceivedPrice') {
      var total = parseInt(userData.prevMemberShip.price);
      var card = parseInt(userData.prevSales.cardPrice);
      var cash = parseInt(userData.prevSales.cashPrice);
      var discount = parseInt(userData.prevSales.discountPrice);

      if ((total - (card + cash + discount)) > 0) return (total - (card + cash + discount)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      else return '0';
    }
    else if (className === 'Approval') return moment(userData.prevSales.approvalDate).format('YY.MM.DD');
    else if (className === 'Validity') {
      if (moment(userData.prevUsage.endDate).diff(moment(), 'day') >= 0) return moment(userData.prevUsage.endDate).diff(moment(), 'day') + t('memberDetail.daysSuffix');
      else return t('memberDetail.statusExpired');
    }
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseOverPrevSales() {
    setPrevSalesColor('#FF8B48');
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseLeavePrevSales() {
    setPrevSalesColor('#595959');
  }

  // 이전 기록 클릭시 회원권 세팅
  function onClickPrevSales() {
    // 수업이 정상 변경 되었으면 실행 //
    if (CategorySelectRef.current.setDefaultValForId(userData.prevMemberShip.categoryId)) {
      // 회원권에 알맞는 수업 찾기 //
      for (var i = 0; i < categoryData.length; i++) {
        if (categoryData[i].id === userData.prevMemberShip.categoryId) {

          var newDataList = [];

          for (var j = 0; j < memberShipData.length; j++) {
            if (memberShipData[j].categoryId === categoryData[i].id) newDataList.push(memberShipData[j]);
          }

          setDivisionMemberShipData(newDataList);
          var result = MemberShipSelectRef.current.setDataAndSetDefaultValForId(newDataList, userData.prevMemberShip.id);

          if (newDataList.length === 0) MemberShipSelectRef.current.setValue({ id: -1, name: '선택' });

          TotalMaxRef.current.setValue(userData.prevMemberShip.totalMax);
          setTotalPrice(userData.prevMemberShip.price);
          CardPaymentRef.current.setValue(userData.prevSales.cardPrice);
          CashPaymentRef.current.setValue(userData.prevSales.cashPrice);
          DiscountPaymentRef.current.setValue(userData.prevSales.discountPrice);
          setNotReceivedPrice(userData.prevSales.notReceivedPrice);
          setValidity(userData.prevMemberShip.validity - 1);

          break;
        }
      }
    }
  }

  return (
    <TotalModalWrapper>
      <TopLevelWrapper>
        <TitleWrapper>
          {/* <MemberShipTitle>회원권 정보</MemberShipTitle> */}
          <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>{t('memberDetail.addMembership')}</Text>
        </TitleWrapper>
        <InfoBox />
        <TitleWrapper style={{ marginTop: `16px` }}>
          <MemberShipTitle>{t('memberDetail.membershipAddModal.prevMembershipInfo')}</MemberShipTitle>
        </TitleWrapper>
        <InfoBox>
          <RowWrapper onClick={onClickPrevSales} onMouseOver={onMouseOverPrevSales} onMouseLeave={onMouseLeavePrevSales}>
            <PrevSalesInfoBoxWrapper width={159} marginRight={28}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.membershipAddModal.membership')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('MemberShipName')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={127} marginRight={31}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.membershipAddModal.period')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Date')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={55} marginRight={28}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.membershipAddModal.maxSessions')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalMax')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={67} marginRight={24}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colPayment')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalPrice')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={67} marginRight={24}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.refundModal.card')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('CardPrice')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={67} marginRight={24}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.refundModal.cash')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('CashPrice')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={67} marginRight={24}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colUnpaid')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('NotReceivedPrice')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={61} marginRight={28}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.refundModal.paymentDate')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Approval')}</Text>
            </PrevSalesInfoBoxWrapper>
            <PrevSalesInfoBoxWrapper width={55}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colRemaining')}</Text>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Validity')}</Text>
            </PrevSalesInfoBoxWrapper>
          </RowWrapper>
        </InfoBox>

        <TitleWrapper style={{ marginTop: `24px` }}>
          <MemberShipTitle>{t('memberDetail.membershipAddModal.paymentInfo')}</MemberShipTitle>
        </TitleWrapper>
        <InfoBox>
          <FirstLayerWrapper>
            <ComponentWrapper>
              <ComponentTitle>{t('memberDetail.membershipAddModal.category')}</ComponentTitle>
              <CategorySelectBox ref={CategorySelectRef} options={categoryData} disabled={isUsing} changeFn={changeCategorySelectVal} />
            </ComponentWrapper>
            <ComponentWrapper>
              <ComponentTitle>{t('memberDetail.membershipAddModal.membership')}</ComponentTitle>
              <MemberShipSelectBox ref={MemberShipSelectRef} disabled={isUsing} data={divisionMemberShipData} changeFn={changeMemberShipSelectVal} />
            </ComponentWrapper>
          </FirstLayerWrapper>
          <SecondLayerWrapper>
            <ComponentWrapper style={{ marginRight: `24px`, gap: '8px' }}>
              <ComponentTitle>{t('memberDetail.membershipAddModal.membershipStartDate')}</ComponentTitle>
              <CalenderInput ref={StartCalenderRef} disabled={isUsing} value={startDate} setValue={setStartDate} className='StartCalender' clickFn={CalenderClick} placeholder={t('memberDetail.membershipAddModal.membershipStartDate')} width={230} />
            </ComponentWrapper>
            <ComponentWrapper style={{ marginRight: `26px`, gap: '8px' }}>
              <ComponentTitle>{t('memberDetail.membershipAddModal.membershipEndDate')}</ComponentTitle>
              <CalenderInput ref={EndCalenderRef} disabled={isUsing} value={endDate} setValue={setEndDate} className='EndCalender' clickFn={CalenderClick} placeholder={t('memberDetail.membershipAddModal.membershipEndDate')} width={230} />
            </ComponentWrapper>
            <ComponentWrapper>
              <MemberShipTotalMaxCountInput ref={TotalMaxRef} noLimitCount={maxCount === -1} explanation={t('memberDetail.membershipAddModal.maxSessionCount')} />
            </ComponentWrapper>
          </SecondLayerWrapper>
          <SecondLayerWrapper style={{ marginTop: '20px' }}>
            <ComponentWrapper style={{ gap: '8px' }}>
              <ComponentTitle>{t('memberDetail.refundModal.paymentDate')}</ComponentTitle>
              <CalenderInput ref={ApprovalCalenderRef} disabled={isUsing} value={approvalDate} setValue={setApprovalDate} className='PaymentCalender' clickFn={CalenderClick} placeholder={t('memberDetail.refundModal.paymentDate')} width={230} />
            </ComponentWrapper>
            <HeightDivisionLine style={{ margin: '0px 22px' }} />
            <ComponentWrapper style={{ marginRight: `20px` }}>
              <ComponentTitle>{t('memberDetail.membershipAddModal.membershipPrice')}</ComponentTitle>
              <CalcPaymentInputWrapper>
                <CalcPaymentInput>{totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</CalcPaymentInput>
                <CalcPaymentUnit>{t('memberDetail.refundModal.won')}</CalcPaymentUnit>
              </CalcPaymentInputWrapper>
            </ComponentWrapper>
            <ComponentWrapper style={{ marginRight: `20px` }}>
              <ComponentTitle>{t('memberDetail.membershipAddModal.cardPaymentAmount')}</ComponentTitle>
              <PaymentInput ref={CardPaymentRef} changeFn={changeValue} width={77} placeholder={0} disabled={isUsing} />
            </ComponentWrapper>
            <ComponentWrapper>
              <ComponentTitle>{t('memberDetail.membershipAddModal.cashPaymentAmount')}</ComponentTitle>
              <PaymentInput ref={CashPaymentRef} changeFn={changeValue} width={77} placeholder={0} disabled={isUsing} />
            </ComponentWrapper>
            <HeightDivisionLine style={{ margin: '0px 22px' }} />
            <ComponentWrapper style={{ marginRight: `20px` }}>
              <ComponentTitle>{t('memberDetail.membershipAddModal.discountAmount')}</ComponentTitle>
              <DiscountPaymentInput ref={DiscountPaymentRef} changeFn={changeValue} width={77} placeholder={0} disabled={isUsing} />
            </ComponentWrapper>
            <ComponentWrapper>
              <TitleTextWrapper>
                <ComponentTitle>{t('memberDetail.membershipAddModal.point')}</ComponentTitle>
                <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color='#6DD49E' cursor='default'>{totalPoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
              </TitleTextWrapper>
              <PointInput ref={PointRef} changeFn={changeValue} width={77} placeholder={0} disabled={isUsing} unit='point'/>
            </ComponentWrapper>
          </SecondLayerWrapper>
          <SecondLayerWrapper style={{ justifyContent: 'flex-end' }}>
            <ComponentWrapper>
              <ComponentTitle>{t('memberDetail.membershipAddModal.unpaidAmount')}</ComponentTitle>
              <CalcPaymentInputWrapper>
                <NotReceivedPaymentInput>{notReceivedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</NotReceivedPaymentInput>
                <CalcPaymentUnit>{t('memberDetail.refundModal.won')}</CalcPaymentUnit>
              </CalcPaymentInputWrapper>
            </ComponentWrapper>
          </SecondLayerWrapper>
        </InfoBox>
        <ButtonBox>
          <ExitButton onClick={cancel}>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='pointer'>{t('memberDetail.modalCancel')}</Text>
          </ExitButton>
          <SaveButton onClick={registerClick}>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{t('memberDetail.modalSave')}</Text>
          </SaveButton>
        </ButtonBox>
      </TopLevelWrapper>
    </TotalModalWrapper>
  )
})

export default MemberShipAddModal;

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1020px;
  // height: 548px;
  height: 618px;

  border-radius: 12px;
  background-color: #FFFFFF;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: space-between;
  align-items: center;

  width: 93%;  
`;

const MemberShipTitle = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  border-top: 2px solid #ECECEC;

  margin-top: 12px;
  width: 93.52%;
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 12px;

  width: 100%;
  height: 60px;

  &:hover {
    cursor: pointer;
  }
`;

const PrevSalesInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: ${props => props.marginRight}px;

  width: ${props => props.width}px;
  height: 48px;

  overflow: hidden;
  gap: 8px;
`;

const FirstLayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  gap: 24px;
  margin-top: 12px;
`;

const SecondLayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: 14px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ComponentTitle = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #000000;

  margin: 0 0 0 0;
`;

const CalcPaymentInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;
  margin-top: 8px;
`;

const CalcPaymentInput = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 8px 0 8px;
  margin: 0 0 0 0;

  width: 77px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #CBCBCB;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FFFFFF;
`;

const CalcPaymentUnit = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  margin: 0 0 0 0;

  color: #000000;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;

const NotReceivedPaymentInput = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 8px;
  margin: 0 0 0 0;

  // width: 77px;
  width: 96px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #FFFFFF;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF3131;
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-end;

  margin-top: 43px;

  width: 93.52%;

  gap: 16px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  // border: 1px solid #DFDFDF;
  border-radius: 10px;
  background-color: #F5F6F8;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #5BD98A;

  &:hover {
    cursor: pointer;
  }
`;

const HeightDivisionLine = styled.div`
  width: 1px;
  height: 100%;

  background-color: #CBCBCB;
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;